
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';

import { KeySelectItem } from '@core/models/select-item.model';


@Component({
    selector: 'form-field-fill-dropdown-selector-v1',
    templateUrl: './fill-dropdown-selector-v1.component.html'
})
export class FillDropdownSelectorV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Choose an option";
    public items: Array<KeySelectItem> = [];
    public valid: boolean = false;
    public selectedOption: string;

    ngOnInit(): void {
        this.emitValidity();
        if(this.fieldSubmission.field.options?.values)
            this.init();
    }

    init(){
        // prepare items to view on selector.
        const currentOptions = this.fieldSubmission.field.options?.values as string[];
        this.items = currentOptions.map((o: string) => ({
            selected: this.fieldSubmission.serialized_value ? this.fieldSubmission.serialized_value === o : false,
            key: o,
            description: o,
            disabled: false
        }));
        if(this.fieldSubmission.serialized_value && this.fieldSubmission.serialized_value.length > 0){
            this.selectedOption = this.fieldSubmission.serialized_value;
            this.valid = true;
            this.emitValidity();
        }
    }

    onSelect(option: KeySelectItem) {
        // TODO save value
        this.valid = true;

        this.selectedOption = option.key;
        this.valid = option && option !== null || !this.fieldSubmission.field.mandatory;
        // console.log(" DROPDOWN onSelect, valid=> ",option, this.valid);
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: option.key});
        this.emitValidity();
    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.fieldSubmission.field.mandatory ? this.valid :  true });
    }

}
